import { memoize } from "lodash";

export const onlyNumbersAndCapitalLetters = memoize(
  (message = "") => (value: string) => {
    if (!value) return undefined;

    const regex = /^[0-9A-Z]+$/;

    if (!regex.test(value)) {
      return message;
    }

    return undefined;
  }
);
